<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <span>设备名称：</span>
                <el-input placeholder="请输入设备名称" v-model="tableSn"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                <el-button type="primary" @click="addRow()">添加</el-button>
            </div>
            <div class="main-table">
                <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" type="index" width="100" fixed></el-table-column>
                    <el-table-column label="设备厂家" width="200">
                        <template slot-scope="scope">
                            <span class="color5" >{{scope.row.equipVender}}</span>
                        </template> 
                    </el-table-column>
                    <el-table-column label="设备名称" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.equipName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="序列号" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.sn }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="型号规格" width="200">
                        <template slot-scope="scope">
                        <span>{{ scope.row.specifications }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="安装单位" width="200">
                        <template slot-scope="scope">
                        <span>{{scope.row.installationUnit}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="检测单位" width="200">
                        <template slot-scope="scope">
                        <span>{{ scope.row.testingUnit }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="检测报告及编号" width="240">
                         <template slot-scope="scope">
                            <span>{{ scope.row.testReportNumber }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column label="检测日期" width="200">
                         <template slot-scope="scope">
                            <span>{{ scope.row.detectionDate }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column label="检测有效期" width="200">
                         <template slot-scope="scope">
                            <span>{{ scope.row.detectionValidityDate }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column label="登记日期" width="240">
                         <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column label="操作" width="300" fixed="right">
                        <template slot-scope="scope">
                          <el-button size="mini" v-if="isMenuExit('pro:elebox:edit')" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                          <el-button size="mini" v-if="isMenuExit('pro:elebox:del')" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                          <el-button size="mini" type="success" @click="history(scope.$index, scope.row)">报检文件</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                ></el-pagination>
            </div>
        </div>
        <!-- 新增设备窗口 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="addVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
        >
            <el-form
                :model="addForm"
                ref="addForm"
                label-width="150px"
                :label-position="labelPosition"
                :rules="rules"
            >
                <el-form-item label="设备厂家：">
                    <el-input v-model="addForm.equipVender" placeholder="请输入设备厂家" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备序列号：">
                    <el-input v-model="addForm.sn" placeholder="请输入设备序列号" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备名称：">
                    <el-input v-model="addForm.equipName" placeholder="请输入设备名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="型号规格：">
                    <el-input v-model="addForm.specifications" placeholder="请输入型号规格" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="安装单位：">
                    <el-input v-model="addForm.installationUnit" placeholder="请输入安装单位" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="检测单位：">
                    <el-input v-model="addForm.testingUnit" placeholder="请输入检测单位" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="检测报告及编号：">
                    <el-input v-model="addForm.testReportNumber" placeholder="请输入检测报告及编号" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="检测日期：">
                    <!-- <el-input v-model="addForm.detectionDate" placeholder="请输入检测日期" autocomplete="off"></el-input> -->
                    <el-date-picker
                        v-model="addForm.detectionDate"
                        align="right"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="检测有效期：">
                    <el-date-picker
                        v-model="addForm.detectionValidityDate"
                        align="right"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                    ></el-date-picker>
                    <!-- <el-input v-model="addForm.detectionValidityDate" placeholder="请输入检测有效期" autocomplete="off"></el-input> -->
                </el-form-item>
                <el-form-item label="检测报告：">
                    <el-upload
                        class="avatar-uploader"
                        v-bind:action="uploadUrl"
                        :headers="uploadHead"
                        :data="{type:230}"
                        :show-file-list="false"
                        :on-success="devSuccess"
                    >
                        <img v-if="addForm.file" src="../../../assets/image/office/pdf.png" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="addForm.remarks" placeholder="备注" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVis = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 文件弹出框 -->
        <el-dialog
            title="报检文件"
            :visible.sync="fileVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="50%"
        >
            <p style="width:100%;height:50px;position: relative;display: flex;justify-content: flex-end;justify-items: flex-end;align-content: center;align-items: center;">
                <el-button size="mini" type="primary" @click="toAddFile">添加文件</el-button>
            </p>
            <el-table :data="fileList" height="600px" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                <template slot="empty">
                    <p>{{fileText}}</p>
                </template>
                <el-table-column label="序号" type="index" width="100"></el-table-column>
                <el-table-column label="检测编号">
                    <template slot-scope="scope">
                        <span >{{scope.row.testReportNumber}}</span>
                    </template> 
                </el-table-column>
                <el-table-column label="有效期">
                    <template slot-scope="scope">
                        <span >{{scope.row.detectionValidityDate}}</span>
                    </template> 
                </el-table-column>
                <el-table-column label="报告文件">
                    <template slot-scope="scope">
                        <span style="cursor: pointer;" @click="toDetail(scope.row)">{{scope.row.fileName}}</span>
                    </template> 
                </el-table-column>
                <el-table-column label="上传日期">
                    <template slot-scope="scope">
                        <span>{{scope.row.detectionDate}}</span>
                    </template> 
                </el-table-column>
                <!-- <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="fileEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column> -->
                <!-- 内弹出 -->
                <el-dialog
                    width="30%"
                    :title="fileTxt"
                    :visible.sync="fileAddVis"
                    append-to-body>
                    <el-form
                        :model="addFile"
                        ref="addFile"
                        label-width="150px"
                        :label-position="labelPosition"
                        :rules="rulesFile"
                    >
                        <el-form-item label="检测编号：" prop="testReportNumber">
                            <el-input v-model="addFile.testReportNumber" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="有效期：" prop="detectionValidityDate">
                            <el-date-picker
                                v-model="addFile.detectionValidityDate"
                                align="right"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="文件：">
                            <el-upload
                                class="avatar-uploader"
                                v-bind:action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:230}"
                                :show-file-list="false"
                                :on-success="handleIconSuccess"
                            >
                                <img v-if="addFile.file" src="../../../assets/image/office/pdf.png" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="fileAddVis = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitFileAdd('addFile')">确 定</el-button>
                    </div>
                </el-dialog>
             </el-table>
        </el-dialog>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
export default {
    data(){
        return{
            tableSn:'',
            tableDataEnd:[],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            dataText:'数据加载中...',
            addVis:false,
            dialogTitle:'',
            labelPosition:'right',
            addForm:{
                id:'',
                projectId:'',
                equipVender:'',  //设备厂家
                sn:'',           //设备序列号
                equipName:'',    //设备名称
                specifications:'',//型号规格
                installationUnit:'',//安装单位
                testingUnit:'',//检测单位
                testReportNumber:'',//检测报告及编号
                detectionDate:'',////检测日期
                detectionValidityDate:'',////检测有效期
                file:'',
                fileName:'',
                remarks:''
            },
            uploadUrl: myHttp.uploadFile, //上传地址
            uploadHead: {
                accessToken: util.session.get('token')
            },
            rules:{
                sn: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }]
            },
            //二维码
            codeVis:false,
            codeUrl:'',
            codeTit:'',
            icon:'',//配电箱图
            http:base.httpCtx,
            machineType:'',

            //报检文件
            fileVis:false,
            fileList:[],
            fileText:'数据加载中...',
            //报检文件内弹出框
            fileTxt:'新增文件',
            fileAddVis:false,
            addFile:{
                id:'',
                projectId:'',
                distributionId:'',
                testReportNumber:'',
                detectionValidityDate:'',
                file:'',
                fileName:'',
                caretBy:'',
            },
            rulesFile:{
                testReportNumber:[
                    { required: true, message: '请选择检测编号', trigger: 'blur' }
                ],
                detectionValidityDate:[{ required: true, message: '请选择有效期', trigger: 'change' }],
            },
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.addForm.projectId = this.groupId
        this.getData()
    },
    methods:{
        getData(){
            var that = this
            myHttp.getDistributionPage({
                equipName:this.tableSn,
                projectId:this.groupId,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.distribution.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                        // list[i].thumbnailUrl = list[i].thumbnailUrl && list[i].thumbnailUrl!=''?list[i].thumbnailUrl:''
                        // list[i].srcList = list[i].thumbnailUrl && list[i].thumbnailUrl!=''?[base.httpCtx+list[i].thumbnailUrl]:[]
                    }
                    that.tableDataEnd = list
                    that.totalItems = resp.data.data.distribution.total
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        handleSizeChange(val) {
          this.pageSize = val
          this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`)
          this.currentPage = val
          this.getData()
        },
        // 监控当前页码
        currentChangePage() {
          this.getData()
        },
        //查询
        doFilter(){
            this.currentPage = 1
            this.getData()
        },

        //添加
        addRow(){
            this.addVis = true
            this.addForm.id = ''
            this.addForm.distributionType = ''
            this.addForm.equipVender=''
            this.addForm.equipName=''    //设备名称
            this.addForm.sn=''    //设备序列号
            this.addForm.specifications=''//型号规格
            this.addForm.installationUnit=''//安装单位
            this.addForm.testingUnit=''//检测单位
            this.addForm.testReportNumber=''//检测报告及编号
            this.addForm.detectionDate=''////检测日期
            this.addForm.detectionValidityDate=''////检测有效期
            this.dialogTitle = '添加'
            this.icon=''
            this.zidian()
        },
        //编辑
        handleEdit(index,row){
            this.zidian()
            this.addVis = true
            this.addForm.id = row.id
            this.addForm.distributionType = row.distributionType
            this.addForm.equipVender=row.equipVender
            this.addForm.equipName=row.equipName   //设备名称
            this.addForm.sn=row.sn   //设备序列号
            this.addForm.specifications=row.specifications//型号规格
            this.addForm.installationUnit=row.installationUnit//安装单位
            this.addForm.testingUnit=row.testingUnit//检测单位
            this.addForm.testReportNumber=row.testReportNumber//检测报告及编号
            this.addForm.detectionDate=row.detectionDate////检测日期
            this.addForm.detectionValidityDate=row.detectionValidityDate////检测有效期
            this.dialogTitle = '修改'
        },
        //删除
        handleDelete(index,row){
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.delDistribution({
                    id: row.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('删除成功')
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            })
        },
        //设备文件提交
        devSuccess(res,file){
            if(res.code=='200'){
                this.addForm.fileName = file.name
                this.addForm.file = res.data.saveUrls
            }else{
                this.$message.error(res.msg)
            }
            console.log(this.addForm.file)
        },
        //提交
        sumbitAddRow(formName){
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    //console.log(that.addForm.id)
                    if(that.addForm.id==''){
                        that.addForm.createBy = util.session.get('user').id
                        myHttp.createDistribution(that.addForm).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('添加成功')
                                    that.addVis = false
                                    that.currentPage = 1
                                    that.getData()
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                    }else{
                        that.addForm.updateBy = util.session.get('user').id
                        myHttp.modDistribution(that.addForm).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('修改成功')
                                    that.addVis = false
                                    that.getData()
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                    }
                }
            })
        },

        /**
         * 判断是否展示
         */
        isMenuExit(row){
            // var flag = util.common.filterBtnMenu(row)
            // return flag
            return true
        },
      //获取字典表
      zidian() {
            var that = this
            myHttp
              .getDictByType({
                type: 'distribution_type'
              })
              .then(function(resp) {
                if (resp.data.code == '200') {
                  var list = resp.data.data.dictList || []
                  that.machineType = list
                }
              })
          },
        /**
         * 获取历史记录
         */
        history(index,row){
            this.fileVis = true
            var that = this
            this.addFile.distributionId = row.id
            myHttp.selectDistributionMaintenanceFile({
                projectId:this.groupId,
                distributionId:this.addFile.distributionId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo||[]
                    that.fileList = list
                    if(list.length==0){
                        that.fileText = '暂无数据'
                    }
                }else{
                    that.fileText = '暂无数据'
                }
            })
        },
        //s刷新检测文件
        refresFile(){
            var that = this
            myHttp.selectDistributionMaintenanceFile({
                projectId:this.groupId,
                distributionId:this.addFile.distributionId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo||[]
                    that.fileList = list
                    if(list.length==0){
                        that.fileText = '暂无数据'
                    }
                }else{
                    that.fileText = '暂无数据'
                }
            })
        },
          // 上传图片
        handleIconSuccess(res, file) {
            if(res.code=='200'){
                this.addFile.fileName = file.name
                this.addFile.file = res.data.saveUrls
            }else{
                this.$message.error(res.msg)
            }
            
        },

        //打开上传文件弹出框
        toAddFile(){
            this.fileAddVis = true
            this.addFile.id = ''
            this.addFile.projectId = this.groupId
            this.addFile.testReportNumber = ''
            this.addFile.detectionValidityDate = ''
            this.addFile.file = ''
            this.addFile.fileName = ''
        },
        //打开
        toDetail(row){
            window.open(base.httpCtx+row.file)
        },
        //编辑
        fileEdit(index,row){

        },
        //文件提交
        sumbitFileAdd(formName){
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if(that.addForm.id==''){
                        that.addForm.caretBy = util.session.get('user').id
                        myHttp.addDistributionMaintenance(that.addFile).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('添加成功')
                                    that.fileAddVis = false
                                    that.refresFile()
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                    }else{
                        // that.addForm.updateBy = util.session.get('user').id
                        // myHttp.modDistribution(that.addForm).then(
                        //     function(resp) {
                        //         if (resp.data.code == '200') {
                        //             that.$message.success('修改成功')
                        //             that.addVis = false
                        //             that.getData()
                        //         } else {
                        //             that.$message.error(resp.data.msg)
                        //         }
                        //     },
                        //     function() {}
                        // )
                    }
                }
            })
        },

    },
}
</script>

<style scoped>
    .main{
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .main-table{
        width: 100%;
        height: calc( 100% - 11.4vh );
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 6vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }
    .build-bar > .el-button {
        margin-left: 30px;
        /* background-color: #17b2fe;
        border-color: #17b2fe; */
    }
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
.avatar{
    width: 100%;
}
</style>

<style>
    @import '../../../assets/css/common.css'
</style>